const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const SPECIAL_RE = /[^A-Za-z0-9]/;
const HTTP_URL_RE = /^https?:\/\/[^\s/$.?#].[^\s]*$/i;
const LOGIN_RE = /^[A-Za-z0-9._-]+$/;

export function validateLoginOrEmail(value) {
  const normalized = String(value || '').trim();
  if (!normalized) return 'Укажи логин или email.';
  if (normalized.includes('@') && !EMAIL_RE.test(normalized)) return 'Некорректный формат email.';
  if (normalized.length < 3) return 'Минимум 3 символа.';
  return '';
}

export function validateEmail(value) {
  const normalized = String(value || '').trim();
  if (!normalized) return 'Укажи email.';
  if (!EMAIL_RE.test(normalized)) return 'Некорректный формат email.';
  return '';
}

export function validateRegisterName(value) {
  const raw = String(value || '').trim();
  const normalized = raw.replace(/\s+/g, '_').slice(0, 50);
  const parts = raw.split(/\s+/).filter(Boolean);
  if (!raw) return 'Укажи ФИО.';
  if (parts.length < 2) return 'Укажи минимум фамилию и имя.';
  if (normalized.length < 3) return 'Логин после преобразования должен быть от 3 символов.';
  return '';
}

export function validateLogin(value) {
  const normalized = String(value || '').trim();
  if (!normalized) return 'Укажи логин.';
  if (normalized.length < 3) return 'Логин должен быть от 3 символов.';
  if (normalized.length > 50) return 'Логин не должен превышать 50 символов.';
  if (!LOGIN_RE.test(normalized)) {
    return 'Логин может содержать только латиницу, цифры, ".", "_" и "-".';
  }
  return '';
}

export function validatePassword(value) {
  const normalized = String(value || '');
  if (normalized.length < 8) return 'Пароль должен быть от 8 символов.';
  if (!/[A-Z]/.test(normalized)) return 'Нужна хотя бы одна заглавная буква.';
  if (!SPECIAL_RE.test(normalized)) return 'Нужен хотя бы один спецсимвол.';
  return '';
}

export function validateLoginPassword(value) {
  const normalized = String(value || '');
  if (!normalized) return 'Укажи пароль.';
  if (normalized.length < 8) return 'Пароль должен быть от 8 символов.';
  return '';
}

export function validatePasswordConfirm(password, confirmPassword) {
  if (!confirmPassword) return 'Повтори пароль.';
  if (password !== confirmPassword) return 'Пароли не совпадают.';
  return '';
}

export function validateReceiverUserId(value) {
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed <= 0) return 'Укажи корректный ID получателя.';
  return '';
}

export function validateTransferAmount(value) {
  const parsed = Number(value);
  if (!Number.isInteger(parsed) || parsed <= 0) return 'Сумма должна быть целым числом больше 0.';
  return '';
}

export function validateAvatarUrl(value) {
  const normalized = String(value || '').trim();
  if (!normalized) return '';
  if (normalized.length > 500) return 'Ссылка на аватар слишком длинная.';
  if (!HTTP_URL_RE.test(normalized)) return 'Укажи корректную ссылку http:// или https://';
  return '';
}

export function mapApiError(operation, error) {
  const status = Number(error?.status || 0);
  const raw = String(error?.message || '').toLowerCase();

  if (operation === 'register') {
    if (
      status === 409 ||
      raw.includes('already exists') ||
      raw.includes('duplicate') ||
      raw.includes('unique')
    ) {
      return 'Пользователь с таким логином или почтой уже существует.';
    }
    if (status === 422) return 'Проверь корректность полей регистрации.';
    if (status === 429) return 'Слишком много попыток. Повтори чуть позже.';
  }

  if (operation === 'login') {
    if (status === 401) return 'Пользователь не найден или неверный пароль.';
    if (status === 403 && raw.includes('подтверд')) {
      return 'Подтверди почту по ссылке из письма, затем войди в аккаунт.';
    }
    if (status === 429) return 'Слишком много попыток входа. Подожди минуту.';
  }

  if (operation === 'transfer') {
    if (raw.includes('same user') || raw.includes('sender and receiver')) {
      return 'Нельзя переводить баллы самому себе.';
    }
    if (raw.includes('receiver') && raw.includes('not found')) {
      return 'Получатель не найден.';
    }
    if (raw.includes('insufficient') || raw.includes('not enough')) {
      return 'Недостаточно баллов для перевода.';
    }
    if (status === 404) return 'Получатель не найден.';
    if (status === 422) return 'Проверь ID получателя и сумму перевода.';
  }

  if (operation === 'profile') {
    if (status === 501 || raw.includes('object storage is disabled')) {
      return 'Загрузка файла недоступна: object storage выключен на сервере.';
    }
    if (status === 422) return 'Некорректная ссылка на аватар.';
  }

  if (status >= 500) {
    return 'Внутренняя ошибка сервера. Попробуй ещё раз чуть позже.';
  }

  return error?.message || 'Произошла ошибка. Попробуй снова.';
}
